module.exports = __webpack_public_path__ + "img/logo_sm.c5da1d86.png";